import React, { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import useGet from "../../../global/hooks/useGet";
import { OrderItemColumns } from "../Page/Column";
// import { OrderItemColumns } from "../Page/Column";

export const OrderTable = ({ paymnetId, orderData }) => {
  const [listData, setListData] = useState([]);
  const [params, setParams] = useState({
    limit: 10,
    sort_by: "OrderNo",
    order: "desc",
  });

  const lisUrl = `${process.env.REACT_APP_API_URL}/api/payments/${paymnetId}/items/${orderData?.OrderNo}`;

  const {
    data: listInfo,
    loading: listInfoLoading,
    error: listDataError,
  } = useGet(lisUrl);

  useEffect(() => {
    if (listInfo && !listInfoLoading) {
      const newData = listInfo?.data?.map((el) => ({
        ...el,
        key: el?.OrderNo,
      }));
      setListData(newData);
    }
  }, [listInfo, listInfoLoading]);

  return (
    <div className="my-2">
      <GlobalTable
        columns={OrderItemColumns(setParams, params)}
        dataSource={listData}
        pagination={false}
        //   onRow={onRow}
      />
    </div>
  );
};
